export const products = [
  {
    Applications:
      "Advertising, ATMs, Automotive , Climate Control, Factory Automation, Gaming/Lottery, Handheld Devices, Health/Fitness/Sports, Home Automation, In-flight Entertainment, Industrial Controls, Kiosks, MedicalDevices, Multimedia, Navigation/Transportation, POS Terminals, Test and Measurement, Wearable Technology, White Goods",
    "DIAGONAL SIZE": "1.08 inch",
    desc: "Sharp’s 1.08-inch (diagonal) Memory-in-Pixel LCD delivers 16.5% reflectivity, making it a perfect display for use in wrist-top applications that require excellent viewability in bright ambient light environments. The monochrome module’s ultra-low-power operation makes it ideal for products that require a battery.",
    PN: "LS011B7DH03",
    "LIFE CYCLE": "Production",
    "CONTRAST RATIO": "20:1",
    REFLECTIVITY: "16.5%",
    "DISPLAY MODE": "Normally White",
    "NUMBER OF COLORS": "Monochrome",
    "OPERATING TEMP": "-20°C to +70°C",
    "STORAGE TEMP": "-30°C to +80°C",
    "OUTLINE DIMENSIONS": "32.00 x 14.00 x 0.745 mm",
    "PIXEL FORMAT": "160 x 68",
    "RESPONSE TIME": "20 ms",
    "VIEWING ANGLE 12 O'CLOCK": "60°",
    "VIEWING ANGLE 6 O'CLOCK": "60°",
    "VIEWING ANGLE SIDE TO SIDE": "120°",
    "Image Hold Power (Typ.)": "15 uW",
    "1Hz Update Power (Typ.)": "25 uW",
    DOCUMENTS: [
      {
        name: "Sharp-LCD-Specification-LS011B7DH03-11-24-17",
        link: require("../assets/Documents/Sharp-LCD-Specification-LS011B7DH03-11-24-17.pdf"),
      },
    ],
    img: [
      require("../assets/Memory in Pixel Drawings/Sharp-LS011B7DH03-Mechanical-Drawing.png"),
    ],
  },
  {
    Applications:
      "Advertising, ATMs, Automotive , Climate Control, Factory Automation, Gaming/Lottery, Handheld Devices, Health/Fitness/Sports, Home Automation, In-flight Entertainment, Industrial Controls, Kiosks, MedicalDevices, Multimedia, Navigation/Transportation, POS Terminals, Test and Measurement, Wearable Technology, White Goods",
    "DIAGONAL SIZE": "1.19 inch Round",
    desc: "This 64-color Memory-in-Pixel LCD module is ideal for wrist-top or handheld applications or virtually any design that requires extremely low power consumption. It delivers smooth graphics in a popular shape, along with the flexibility to support rich custom content.",
    PN: "LS012B7DD06A",
    "LIFE CYCLE": "Production",
    "CONTRAST RATIO": "25:1",
    REFLECTIVITY: "8.4%",
    "DISPLAY MODE": "Normally Black",
    "NUMBER OF COLORS": "64",
    "OPERATING TEMP": "-20°C to +70°C",
    "STORAGE TEMP": "-30°C to +80°C",
    "OUTLINE DIMENSIONS": "33.04 × 33.94 × 0.89 mm",
    "PIXEL FORMAT": "240 x 240",
    "RESPONSE TIME": "20 ms",
    "VIEWING ANGLE 12 O'CLOCK": "60°",
    "VIEWING ANGLE 6 O'CLOCK": "60°",
    "VIEWING ANGLE SIDE TO SIDE": "120°",
    "Image Hold Power (Typ.)": "11 uW",
    "1Hz Update Power (Typ.)": "33 uW",
    img: [
      require("../assets/Memory in Pixel Drawings/Sharp-LS012B7DD06A-Mechanical-Drawing.png"),
    ],
    DOCUMENTS: [
      {
        name: "Sharp-LCD-Specification-LS012B7DD06A-12-2-19",
        link: require("../assets/Documents/Sharp-LCD-Specification-LS012B7DD06A-12-2-19.pdf"),
      },
    ],
  },
  {
    Applications:
      "Advertising, ATMs, Automotive , Climate Control, Factory Automation, Gaming/Lottery, Handheld Devices, Health/Fitness/Sports, Home Automation, In-flight Entertainment, Industrial Controls, Kiosks, MedicalDevices, Multimedia, Navigation/Transportation, POS Terminals, Test and Measurement, Wearable Technology, White Goods",
    "DIAGONAL SIZE": "1.26 inch",
    desc: "This 1.26-inch (diagonal), slightly transmissive display delivers smooth graphics with the flexibility to support rich content. 1 bit of internal memory for data storage inside the panel results in extremely low power consumption (35 µW typical in a static state). This makes the display perfect for small-screen applications where power-saving is a must.",
    PN: "LS013B7DH05",
    "LIFE CYCLE": "Production",
    "CONTRAST RATIO": "20:1",
    REFLECTIVITY: "14.5%",
    "DISPLAY MODE": "Normally White",
    "NUMBER OF COLORS": "Monochrome",
    "OPERATING TEMP": "-20°C to +70°C",
    "STORAGE TEMP": "-30°C to +80°C",
    "OUTLINE DIMENSIONS": "24.68 x 30.00  x 0.745 mm",
    "PIXEL FORMAT": "144 x 168",
    "RESPONSE TIME": "20 ms",
    "VIEWING ANGLE 12 O'CLOCK": "60°",
    "VIEWING ANGLE 6 O'CLOCK": "60°",
    "VIEWING ANGLE SIDE TO SIDE": "120°",
    "Image Hold Power (Typ.)": "25 uW",
    "1Hz Update Power (Typ.)": "35 uW",
    img: [
      require("../assets/Memory in Pixel Drawings/Sharp-LS013B7DH05-Mechanical-Drawing.png"),
    ],
    DOCUMENTS: [
      {
        name: "Sharp-LCD-Specification-LS013B7DH05-12-17-19",
        link: require("../assets/Documents/Sharp-LCD-Specification-LS013B7DH05-12-17-19.pdf"),
      },
    ],
  },

  {
    Applications:
      "Advertising, ATMs, Automotive , Climate Control, Factory Automation, Gaming/Lottery, Handheld Devices, Health/Fitness/Sports, Home Automation, In-flight Entertainment, Industrial Controls, Kiosks, MedicalDevices, Multimedia, Navigation/Transportation, POS Terminals, Test and Measurement, Wearable Technology, White Goods",
    "DIAGONAL SIZE": "1.28 inch",
    desc: "This highly-relfiective plus Transmissive Memory LCD has 18% Reflectivity, 0.2% Transmissivity, and super-low-power-consumption.",
    PN: "LS013B7DH03",
    "LIFE CYCLE": "Production",
    "CONTRAST RATIO": "18:1",
    REFLECTIVITY: "18.0%",
    "DISPLAY MODE": "Normally White",
    "NUMBER OF COLORS": "Monochrome",
    "OPERATING TEMP": "-20°C to +70°C",
    "STORAGE TEMP": "-30°C to +80°C",
    "OUTLINE DIMENSIONS": "26.6 × 30.3 × 0.741 mm",
    "PIXEL FORMAT": "128 × 128",
    "RESPONSE TIME": "20 ms",
    "VIEWING ANGLE 12 O'CLOCK": "60°",
    "VIEWING ANGLE 6 O'CLOCK": "60°",
    "VIEWING ANGLE SIDE TO SIDE": "120°",
    "Image Hold Power (Typ.)": "12 uW",
    "1Hz Update Power (Typ.)": "50 uW",
    img: [
      require("../assets/Memory in Pixel Drawings/Sharp-LS013B7DH03-Mechanical-Drawing.png"),
    ],
    DOCUMENTS: [
      {
        name: "Sharp-LCD-Specification-LS013B7DH03-10-7-17",
        link: require("../assets/Documents/Sharp-LCD-Specification-LS013B7DH03-10-7-17.pdf"),
      },
    ],
  },
  {
    Applications:
      "Advertising, ATMs, Automotive , Climate Control, Factory Automation, Gaming/Lottery, Handheld Devices, Health/Fitness/Sports, Home Automation, In-flight Entertainment, Industrial Controls, Kiosks, MedicalDevices, Multimedia, Navigation/Transportation, POS Terminals, Test and Measurement, Wearable Technology, White Goods",
    "DIAGONAL SIZE": "1.29 inch Round",
    desc: "This round 1.29-inch (diagonal) Memory-in-Pixel LCD renders 64 colors with an 18% NTSC ratio. This combines with a 25:1 contrast ratio to deliver high-quality images–static or moving–in a variety of lighting environments. The module’s reflective mode and ultra-low-power requirements make it perfect for wrist-top applications that require a battery.",
    PN: "LS013B7DD02",
    "LIFE CYCLE": "Pre-production",
    "CONTRAST RATIO": "25:1",
    REFLECTIVITY: "9.0%",
    "DISPLAY MODE": "Normally Black",
    "NUMBER OF COLORS": "64",
    "OPERATING TEMP": "-20°C to +70°C",
    "STORAGE TEMP": "-30°C to +80°C",
    "OUTLINE DIMENSIONS": "35.56 x 36.26 x 0.91 mm",
    "PIXEL FORMAT": "260 x 260",
    "RESPONSE TIME": "20 ms",
    "VIEWING ANGLE 12 O'CLOCK": "60°",
    "VIEWING ANGLE 6 O'CLOCK": "60°",
    "VIEWING ANGLE SIDE TO SIDE": "120°",
    "Image Hold Power (Typ.)": "3 uW",
    "1Hz Update Power (Typ.)": "12 uW",
    img: [
      require("../assets/Memory in Pixel Drawings/Sharp-LS013B7DD02-Technical-Drawing.jpg"),
    ],
    DOCUMENTS: [
      {
        name: "Sharp-Tech-Literature-LS013B7DD02-12-2-19",
        link: require("../assets/Documents/Sharp-Tech-Literature-LS013B7DD02-12-2-19.pdf"),
      },
    ],
  },
  {
    Applications:
      "Advertising, ATMs, Automotive , Climate Control, Factory Automation, Gaming/Lottery, Handheld Devices, Health/Fitness/Sports, Home Automation, In-flight Entertainment, Industrial Controls, Kiosks, MedicalDevices, Multimedia, Navigation/Transportation, POS Terminals, Test and Measurement, Wearable Technology, White Goods",
    "DIAGONAL SIZE": "1.39 inch Round",
    desc: "This round 1.39-inch (diagonal) Memory-in-Pixel LCD renders 64 colors with an 18% NTSC ratio. This combines with a 25:1 contrast ratio to deliver high-quality images–static or moving–in a variety of lighting environments. The module’s reflective mode and ultra-low-power requirements make it perfect for wrist-top applications that require a battery.",
    PN: "LS014B7DD01",
    "LIFE CYCLE": "Pre-production",
    "CONTRAST RATIO": "25:1",
    REFLECTIVITY: "8.70%",
    "DISPLAY MODE": "Normally Black",
    "NUMBER OF COLORS": "64",
    "OPERATING TEMP": "-20°C to +70°C",
    "STORAGE TEMP": "-30°C to +80°C",
    "OUTLINE DIMENSIONS": "38.08 x 38.78 x 0.91 mm",
    "PIXEL FORMAT": "280 x 280",
    "RESPONSE TIME": "20 ms",
    "VIEWING ANGLE 12 O'CLOCK": "60°",
    "VIEWING ANGLE 6 O'CLOCK": "60°",
    "VIEWING ANGLE SIDE TO SIDE": "120°",
    "Image Hold Power (Typ.)": "3.4 uW",
    "1Hz Update Power (Typ.)": "14 uW",
    img: [
      require("../assets/Memory in Pixel Drawings/Sharp-LS014B7DD01-Mechanical-Drawing.jpg"),
    ],
    DOCUMENTS: [
      {
        name: "LS014B7DD01 Spec.",
        link: require("../assets/Documents/LS014B7DD01_Spec_LCP-0620031B.pdf"),
      },
    ],
  },
  {
    Applications:
      "Advertising, ATMs, Automotive , Climate Control, Factory Automation, Gaming/Lottery, Handheld Devices, Health/Fitness/Sports, Home Automation, In-flight Entertainment, Industrial Controls, Kiosks, MedicalDevices, Multimedia, Navigation/Transportation, POS Terminals, Test and Measurement, Wearable Technology, White Goods",
    "DIAGONAL SIZE": "1.80 inch",
    desc: "Sharp’s Memory-in-Pixel LCDs deliver high performance with ultra-low power operation. This monochrome 1.80-inch module features a reflectivity of 15.5% and a contrast ratio of 25:1, making it ideal for viewing in bright sunlight.",
    PN: "LS018B7DH02",
    "LIFE CYCLE": "Production",
    "CONTRAST RATIO": "25:1",
    REFLECTIVITY: "15.5%",
    "DISPLAY MODE": "Normally White",
    "NUMBER OF COLORS": "Monochrome",
    "OPERATING TEMP": "-20°C to +70°C",
    "STORAGE TEMP": "-30°C to +80°C",
    "OUTLINE DIMENSIONS": "31.00 x 41.46 x 0.745 mm",
    "PIXEL FORMAT": "230 x 303",
    "RESPONSE TIME": "20 ms",
    "VIEWING ANGLE 12 O'CLOCK": "60°",
    "VIEWING ANGLE 6 O'CLOCK": "60°",
    "VIEWING ANGLE SIDE TO SIDE": "120°",
    "Image Hold Power (Typ.)": "15 uW",
    "1Hz Update Power (Typ.)": "100 uW",
    img: [
      require("../assets/Memory in Pixel Drawings/Sharp-LS018B7DH02-Mechanical-Drawing.jpg"),
    ],
    DOCUMENTS: [
      // {
      //   name: "Sharp-LCD-Specification-LS018B7DH02-10-2-17",
      //   link: require("../assets/Documents/Sharp-LCD-Specification-LS018B7DH02-10-2-17.pdf"),
      // },
      {
        name: "Sharp-LCD-Specification-LS018B7DH02-2-25-19",
        link: require("../assets/Documents/Sharp-LCD-Specification-LS018B7DH02-2-25-19.pdf"),
      },
    ],
  },
  {
    Applications:
      "Advertising, ATMs, Automotive , Climate Control, Factory Automation, Gaming/Lottery, Handheld Devices, Health/Fitness/Sports, Home Automation, In-flight Entertainment, Industrial Controls, Kiosks, MedicalDevices, Multimedia, Navigation/Transportation, POS Terminals, Test and Measurement, Wearable Technology, White Goods",
    "DIAGONAL SIZE": "2.13 inch",
    desc: "This Sharp Memory-in-Pixel LCD delivers static or moving images in 64 colors, making it perfect for a variety of wrist-top and handheld products. The TFT-module’s reflective mode and ultra-low-power requirements make it perfect for wrist-top applications that require a battery.",
    PN: "LS021B7DD02",
    "LIFE CYCLE": "Production",
    "CONTRAST RATIO": "25:1",
    REFLECTIVITY: "9.0%",
    "DISPLAY MODE": "Normally Black",
    "NUMBER OF COLORS": "64",
    "OPERATING TEMP": "-20°C to +70°C",
    "STORAGE TEMP": "-30°C to +80°C",
    "OUTLINE DIMENSIONS": "35.4 x 48.6 x 0.91 mm",
    "PIXEL FORMAT": "240 x 320",
    "RESPONSE TIME": "20 ms",
    "VIEWING ANGLE 12 O'CLOCK": "60°",
    "VIEWING ANGLE 6 O'CLOCK": "60°",
    "VIEWING ANGLE SIDE TO SIDE": "120°",
    "Image Hold Power (Typ.)": "1.14 uW",
    "1Hz Update Power (Typ.)": "15.2 uW",
    img: [
      require("../assets/Memory in Pixel Drawings/Sharp-LS021B7DD02-Mechanical-Drawing.jpg"),
    ],
    DOCUMENTS: [
      {
        name: "LS021B7DD02_Spec_LCP-0620032_201201",
        link: require("../assets/Documents/LS021B7DD02_Spec_LCP-0620032_201201.pdf"),
      },
    ],
  },
  {
    Applications:
      "Industrial security/keypad; HVAC UI control; Hand-held industrial metering and detection; Small marine peripheral devices; Sport computers: Golf, hiking, boating, biking; Medical: Portable and wearables; Consumer wearables; Remote, battery-powered device; IOT devices w/user interface; Outdoor equipment",
    "DIAGONAL SIZE": "2.16 inch",
    desc: "This high-contrast, high-reflectivity 2.16-inch Memory in Pixel display provides excellent viewability in high-ambient environments and can be either front-lit or back-lit. It features a 24Hz refresh for smooth animations and transitions, and its low power operation requires just 80uW for a static image hold and 100uW @ 1Hz update.",
    PN: "LS022B7DH03",
    "LIFE CYCLE": "Production",
    "CONTRAST RATIO": "18:1",
    REFLECTIVITY: "16.6%",
    "DISPLAY MODE": "Normally White",
    "NUMBER OF COLORS": "Monochrome",
    "OPERATING TEMP": "-15° to 70°C",
    "STORAGE TEMP": "-30°C to +80°C",
    "OUTLINE DIMENSIONS": "35.48 x 48.54 x 0.745 mm",
    "PIXEL FORMAT": "240 x 320",
    "RESPONSE TIME": "20 ms",
    "VIEWING ANGLE 12 O'CLOCK": "60°",
    "VIEWING ANGLE 6 O'CLOCK": "60°",
    "VIEWING ANGLE SIDE TO SIDE": "120°",
    "Image Hold Power (Typ.)": "80 uW",
    "1Hz Update Power (Typ.)": "100 uW",
    DOCUMENTS: [
      {
        name: "Sharp-LCD-Specification-LS022B7DH03_SPEC_LD2023X09",
        link: require("../assets/Documents/LS022B7DH03_SPEC_LD2023X09_20231017.pdf"),
      },
    ],
    img: [require("../assets/Memory in Pixel Drawings/Sharp-LS022B7DH03.png")],
  },
  {
    Applications:
      "Advertising, ATMs, Automotive , Climate Control, Factory Automation, Gaming/Lottery, Handheld Devices, Health/Fitness/Sports, Home Automation, In-flight Entertainment, Industrial Controls, Kiosks, MedicalDevices, Multimedia, Navigation/Transportation, POS Terminals, Test and Measurement, Wearable Technology, White Goods",
    "DIAGONAL SIZE": "2.70 inch",
    desc: "This HR-TFT Transflective model is Sharp's first Transflective Memory LCD. Add a backlight with this display for excellent viewing in dark ambient conditions. ",
    PN: "LS027B7DH01A",
    "LIFE CYCLE": "Production",
    "CONTRAST RATIO": "14:1",
    REFLECTIVITY: "17.5%",
    "DISPLAY MODE": "Normally White",
    "NUMBER OF COLORS": "Monochrome",
    "OPERATING TEMP": "-20°C to +70°C",
    "STORAGE TEMP": "-30°C to +80°C",
    "OUTLINE DIMENSIONS": "62.8 × 42.82 × 1.64 mm",
    "PIXEL FORMAT": "400 × 240",
    "RESPONSE TIME": "20 ms",
    "VIEWING ANGLE 12 O'CLOCK": "60°",
    "VIEWING ANGLE 6 O'CLOCK": "60°",
    "VIEWING ANGLE SIDE TO SIDE": "110°",
    "Image Hold Power (Typ.)": "50 uW",
    "1Hz Update Power (Typ.)": "175 uW",
    img: [
      require("../assets/Memory in Pixel Drawings/Sharp-LS027B7DH01A-Mechanical-Drawing.png"),
    ],
    DOCUMENTS: [
      {
        name: "LS027B7DH01 Spec (LD-28305A)",
        link: require("../assets/Documents/LS027B7DH01 Spec (LD-28305A).pdf"),
      },
      // {
      //   name: "Sharp-IIS-LS027B7DH01A-11-27-13",
      //   link: require("../assets/Documents/Sharp-IIS-LS027B7DH01A-11-27-13.pdf"),
      // },
    ],
  },
  {
    Applications:
      "Advertising, ATMs, Automotive , Climate Control, Factory Automation, Gaming/Lottery, Handheld Devices, Health/Fitness/Sports, Home Automation, In-flight Entertainment, Industrial Controls, Kiosks, MedicalDevices, Multimedia, Navigation/Transportation, POS Terminals, Test and Measurement, Wearable Technology, White Goods",
    "DIAGONAL SIZE": "3.16 inch",
    desc: "This Transflective panel features an FPC connector. Add a backlight with this display for excellent viewing in all ambients.",
    PN: "LS032B7DD02",
    "LIFE CYCLE": "Production",
    "CONTRAST RATIO": "35:1",
    REFLECTIVITY: "14.0%",
    "DISPLAY MODE": "Normally White",
    "NUMBER OF COLORS": "Monochrome",
    "OPERATING TEMP": "-20°C to +70°C",
    "STORAGE TEMP": "-30°C to +80°C",
    "OUTLINE DIMENSIONS": "47.02 × 76.0 × 0.705 mm",
    "PIXEL FORMAT": "336 × 536",
    "RESPONSE TIME": "20 ms",
    "VIEWING ANGLE 12 O'CLOCK": "60°",
    "VIEWING ANGLE 6 O'CLOCK": "60°",
    "VIEWING ANGLE SIDE TO SIDE": "120°",
    "Image Hold Power (Typ.)": "30 uW",
    "1Hz Update Power (Typ.)": "250 uW",
    img: [
      require("../assets/Memory in Pixel Drawings/Sharp-LS032B7DD02-Mechanical-Drawing.png"),
    ],
    DOCUMENTS: [
      {
        name: "Sharp-LCD-Specification-LS032B7DD02-6-19-17",
        link: require("../assets/Documents/Sharp-LCD-Specification-LS032B7DD02-6-19-17.pdf"),
      },
    ],
  },
  {
    Applications:
      "Industrial security/keypad; HVAC UI control; Hand-held industrial metering and detection; Small marine peripheral devices; Sport computers: Golf, hiking, boating, biking; Medical: Portable and wearables; Consumer wearables; Remote, battery-powered device; IOT devices w/user interface; Outdoor equipment",
    "DIAGONAL SIZE": "3.54 inch",
    desc: "This high-contrast, highly-reflective 3.5-inch (diagonal) 64-color Memory in Pixel display (part number LS035Q7DD01) renders color at 18% NTSC and is 9.0% reflective, which makes images pop even in direct sunlight or high ambient lighting scenarios. It features an 18Hz refresh rate for smooth animations and transitions, and its low-power operation requires just 1uW for a static image hold and 23uW for a 1Hz update.",
    PN: "LS035Q7DD01",
    "LIFE CYCLE": "Production",
    "CONTRAST RATIO": "25:1",
    REFLECTIVITY: "9.0%",
    "DISPLAY MODE": "Normally Black",
    "NUMBER OF COLORS": "64",
    "OPERATING TEMP": "-20°C to +70°C",
    "STORAGE TEMP": "-30°C to +80°C",
    "OUTLINE DIMENSIONS": "74.84 × 59.92 × 0.91 mm",
    "PIXEL FORMAT": "320 × 240",
    "RESPONSE TIME": "20 ms",
    "VIEWING ANGLE 12 O'CLOCK": "60°",
    "VIEWING ANGLE 6 O'CLOCK": "60°",
    "VIEWING ANGLE SIDE TO SIDE": "120°",
    "Image Hold Power (Typ.)": "1.05 uW",
    "1Hz Update Power (Typ.)": "22.8 uW",
    img: [
      require("../assets/Memory in Pixel Drawings/LS035Q7DD01_SPEC_LD2023702A.jpg"),
      require("../assets/Memory in Pixel Drawings/Sharp-MIP-3-5-inch-LS035Q7DD01.jpg"),
    ],
    DOCUMENTS: [
      {
        name: "Sharp-LCD-Specification-LS035Q7DD01_LD2023702A_2023.10.25",
        link: require("../assets/Documents/LS035Q7DD01_SPEC_LD2023702A_2023.10.25.pdf"),
      },
    ],
  },
  {
    Applications:
      "Advertising, ATMs, Automotive , Climate Control, Factory Automation, Gaming/Lottery, Handheld Devices, Health/Fitness/Sports, Home Automation, In-flight Entertainment, Industrial Controls, Kiosks, MedicalDevices, Multimedia, Navigation/Transportation, POS Terminals, Test and Measurement, Wearable Technology, White Goods",
    "DIAGONAL SIZE": "4.40 inch",
    desc: "This Transflective monochrome panel features QVGA resolution and is ideal for applications such as Industrial Controls, as well as most other battery-operated devices that require an LCD with Landscape orientation. Its dot matrix display delivers smooth graphics and the flexibility to showcase rich custom content.",
    PN: "LS044Q7DH01",
    "LIFE CYCLE": "Production",
    "CONTRAST RATIO": "18:1",
    REFLECTIVITY: "18.0%",
    "DISPLAY MODE": "Normally White",
    "NUMBER OF COLORS": "Monochrome",
    "OPERATING TEMP": "-20°C to +70°C",
    "STORAGE TEMP": "-30°C to +80°C",
    "OUTLINE DIMENSIONS": "94.8 × 75.2 × 1.64 mm",
    "PIXEL FORMAT": "320 × 240",
    "RESPONSE TIME": "20 ms",
    "VIEWING ANGLE 12 O'CLOCK": "60°",
    "VIEWING ANGLE 6 O'CLOCK": "60°",
    "VIEWING ANGLE SIDE TO SIDE": "120°",
    "Image Hold Power (Typ.)": "100 uW",
    "1Hz Update Power (Typ.)": "600 uW",
    img: [
      require("../assets/Memory in Pixel Drawings/Sharp-LS044Q7DH01-Mechanical-Drawing.png"),
    ],
    DOCUMENTS: [
      {
        name: "Sharp-LCD-Specification-LS044Q7DH01-10-17-19",
        link: require("../assets/Documents/Sharp-LCD-Specification-LS044Q7DH01-10-17-19.pdf"),
      },
    ],
  },
];
